import { app, translate } from '../app'
import { Container } from './container'
import HomePageCards from './home-page-cards'
import { languages } from '../locale'
import { useAnimateOnScroll } from './useAnimateOnScroll'
import { SplitText } from "./splittext"
import { CategoryGrid } from "./category-grid"
import { LatestArticles } from "./latest-articles"

const colors = ['#FDF1B1', '#F9D79E', '#ABDFBF', '#C0E1E0', '#B1C3FB', '#CDA9E9']

export function BlockCategories(props: { block: BlockCategories }) {
  const { block } = props
  useAnimateOnScroll()
  const locale = (languages[app.locale]?.zendesk as string) ?? app.locale

  const categories: ZendeskCategory[] = Object.values(app.data.zendesk.categories)

  const isRTL = languages[app.locale]?.rtl

  return (
    <Container block={block} className={isRTL ? 'rtl' : ''}>
      <h1
        id="category-title"
        className={`fade-up-0 mt-0 text-[36px] md:text-[44px] font-bold leading-[44px] md:leading-[56px] ${isRTL ? 'text-right' : 'text-left'}`}
        style={{ direction: isRTL ? "rtl" : "ltr" }}
        data-animation='animate__fadeInUp'
      >
        <SplitText text={translate(block.title)} />
      </h1>
      <h2
        className={`fade-up-1 text-neutral-icon font-inter text-[20px] font-normal leading-[32px] mt-0 mb-6 animate__animated animate__fadeInUp ${isRTL ? 'text-right' : 'text-left'}`}
        style={{ direction: isRTL ? "rtl" : "ltr" }}
        data-animation='animate__fadeInUp'
      >
        <SplitText text={translate(block.subtitle)} />
      </h2>
      <div className='fade-up-2' data-animation='animate__fadeInUp'>
        <CategoryGrid />
      </div>
      <div className='fade-up-2' data-animation='animate__fadeInUp'>
        <LatestArticles />
      </div>
    </Container>
  )
}
